import React, { Component } from 'react'

import Datagrid from '@/ui/DataTable/Datagrid'
import ListTable from '@/ui/DataTable/List'

import { AvatarField, ButtonField, CombinedField, TextField } from '@/ui/Data' // eslint-disable-line
import { Container, Row, Cell } from '@/ui/Element'
import { Button, ButtonGroup, EditButton } from '@/ui/Button'
import { Tooltip } from '@/ui/Tooltip'

import { showModal, hideModal } from '@/state/actions/modal'
import { crudDelete } from '@/state/actions/data'
import { routeUsersEdit } from '@/state/actions/routes'

import DeleteIcon from '@/icons/Delete'
import EditIcon from '@/icons/Edit'

class Users extends Component {
  close = () => {
    this.props.dispatch(hideModal())
  }

  delete = record => {
    this.props.dispatch(
      crudDelete('users', record.id, false, { message: `${record.full_name} deleted.` }),
    )
    this.props.dispatch(hideModal())
  }

  edit = record => {
    this.props.dispatch(routeUsersEdit(record.id))
  }

  remove = record => {
    this.props.dispatch(
      showModal({
        title: 'Permanently delete $full_name?',
        record: record,
        content:
          `This will permanently delete $full_name from the team list. ` +
          `All related items will remain. This action is irreversible.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="danger" key="delete" onClick={() => this.delete(record)}>
            Delete
          </Button>,
        ],
      }),
    )
  }

  render() {
    const { theme, ...props } = this.props
    return (
      <Container>
        <Row spacing="double">
          <Cell>
            <ListTable {...props} resource="users" title={false}>
              <Datagrid>
                <CombinedField label="Team members" cellName="user" className={theme['user-col']}>
                  <AvatarField source="picture" fallback="full_name" letter />
                  <EditButton source="full_name" title={false} click={this.edit} theme={theme} />
                </CombinedField>
                <ButtonGroup width="10rem" label="Manage">
                  <ButtonField
                    tag="div"
                    sortable={false}
                    click={this.edit}
                    classes={['flex-center', 'flex-middle']}
                  >
                    <Tooltip content="Edit user">
                      <EditIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" sortable={false} click={this.remove}>
                    <Tooltip content="Delete user">
                      <DeleteIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                </ButtonGroup>
              </Datagrid>
            </ListTable>
          </Cell>
        </Row>
      </Container>
    )
  }
}
export default Users



// WEBPACK FOOTER //
// ./view/Users/Users.js